import { ReqGantiJadwalDetailsComponent } from './details-req-ganti-jadwal.component';

export default ReqGantiJadwalDetailsComponent;
